'use strict';

/**
 * @fileOverview Основной файл инициализации модулей
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import './_vendors/promise-polyfill';
import './_vendors/jquery';


import './_modules/lazy-load';
import horizontalScroll from './_modules/horizontal-scroll';
import wrapMedia from './_modules/wrap-media';
import validate from './_modules/validation/validate';
import mfpAjax from './_modules/mfp/mfp-ajax';
import mfpInline from './_modules/mfp/mfp-inline';
import mfpIframe from './_modules/mfp/mfp-iframe';
import mfpGallery from './_modules/mfp/mfp-gallery';
import {mainMenu, filtersMenu, scrollTo} from './_modules/menu';
import {mainSlider, offerSlider, similarSlider, photoSlider} from './_modules/sliders';
import {profitCalculator} from './_modules/profit-calculator';
import {onlineCalculator} from './_modules/online-calculator';
import {headerScrollMagic, firstSlideAnimation, calculationScrollMagic, infoScrollMagic, productScrollMagic} from './_modules/scrollmagic';
import {headerLang, headerSearch} from './_modules/header';
import {initSelect} from './_modules/select';
import {subMenuToggle} from './_modules/sub-menu';
import {initRangeSlider} from './_modules/range-slider';
import {textWrap} from './_modules/text-wrap';
import {initMap} from './_modules/map';
import wsTabs from './_modules/wstabs';
import {selectWord} from './_modules/select-word';

import videoController from './_modules/video';

// ----------------------------------------
// Public
// ----------------------------------------

window.jQuery(document).ready($ => {
	horizontalScroll('.wysiwyg table');
	wrapMedia('.wysiwyg iframe, .wysiwyg video');
	validate('.js-form');
	mfpAjax();
	mfpInline();
	mfpIframe();
	mfpGallery();
	mainMenu();
	mainSlider();
	profitCalculator();
	headerScrollMagic();
	calculationScrollMagic();
	infoScrollMagic();
	firstSlideAnimation();
	offerSlider();
	headerLang();
	headerSearch();
	initSelect();
	subMenuToggle('.sidebar-menu-toggle', '.sidebar__menu-item--child', '.sidebar__sub-menu');
	initRangeSlider();
	filtersMenu();
	similarSlider();
	photoSlider();
	productScrollMagic();
	textWrap();
	onlineCalculator();
	initMap();
	wsTabs.init();
	wsTabs.setActive(); // если нужно принудительно активировать табы
	scrollTo();
	selectWord();

	videoController('.js-mainSlider');




});

if (IS_PRODUCTION) {
	require('./_modules/wezom-log');
}



// WEBPACK FOOTER //
// ./_HTML/src/js/entry.js